import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/globals.css");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/navbar.tsx")